import { useTranslation } from 'react-i18next'
import { SEO } from '@/components/SEO'
import { Hero } from '@/components/Hero'
import { Section } from '@/components/Section'

export function PrivacyPage() {
  const { t } = useTranslation()

  return (
    <>
      <SEO
        title={t('privacy.metaTitle')}
        description={t('privacy.metaDescription')}
        noIndex
      />

      <Hero
        title={t('privacy.heroTitle')}
        size="sm"
      />

      <Section>
        <div className="mx-auto max-w-4xl">
          <div className="prose prose-lg max-w-none prose-headings:text-secondary-900 prose-p:text-secondary-600 prose-li:text-secondary-600">
            <p className="text-sm text-secondary-500">
              {t('privacy.lastUpdated')}: January 1, 2026
            </p>

            <h2>1. {t('privacy.section1Title')}</h2>
            <p>{t('privacy.section1Text')}</p>

            <h2>2. {t('privacy.section2Title')}</h2>
            <p>{t('privacy.section2Text')}</p>
            <ul>
              <li>{t('privacy.dataType1')}</li>
              <li>{t('privacy.dataType2')}</li>
              <li>{t('privacy.dataType3')}</li>
              <li>{t('privacy.dataType4')}</li>
            </ul>

            <h2>3. {t('privacy.section3Title')}</h2>
            <p>{t('privacy.section3Text')}</p>
            <ul>
              <li>{t('privacy.purpose1')}</li>
              <li>{t('privacy.purpose2')}</li>
              <li>{t('privacy.purpose3')}</li>
              <li>{t('privacy.purpose4')}</li>
            </ul>

            <h2>4. {t('privacy.section4Title')}</h2>
            <p>{t('privacy.section4Text')}</p>

            <h2>5. {t('privacy.section5Title')}</h2>
            <p>{t('privacy.section5Text')}</p>

            <h2>6. {t('privacy.section6Title')}</h2>
            <p>{t('privacy.section6Text')}</p>
            <ul>
              <li>{t('privacy.right1')}</li>
              <li>{t('privacy.right2')}</li>
              <li>{t('privacy.right3')}</li>
              <li>{t('privacy.right4')}</li>
              <li>{t('privacy.right5')}</li>
            </ul>

            <h2>7. {t('privacy.section7Title')}</h2>
            <p>{t('privacy.section7Text')}</p>

            <h2>8. {t('privacy.section8Title')}</h2>
            <p>{t('privacy.section8Text')}</p>

            <h2>9. {t('privacy.section9Title')}</h2>
            <p>
              Chemical Newtech S.p.A.<br />
              Via Piemonte, 19<br />
              25031 Capriolo (BS), Italia<br />
              Email: privacy@chemicalnewtech.com<br />
              Tel: +39 030 7460669
            </p>
          </div>
        </div>
      </Section>
    </>
  )
}
